import { subscribe } from '@wordpress/data';

import PatternlyWrap from "./component/PatternlyWrap";

/**
 * Import the stylesheet
 */
import './style.scss';

document.addEventListener( 'DOMContentLoaded', function () {
    // create patternly button
    const patternWrapper = document.createElement('div');
    patternWrapper.classList.add('pat-library-button-wrapper');
    ReactDOM.render(<PatternlyWrap />, patternWrapper);
    
    subscribe(() => {
        const toolbar = document.querySelector('.edit-post-header-toolbar')
        if (toolbar) {
            toolbar.appendChild(patternWrapper);
        }
    })

});
